import { Modifier } from './modifier';
import type { TraitType } from './trait-registry';

export class Trait extends Modifier {
  constructor(traitDefinition: traitDefinition) {
    super();
    if (traitDefinition) {
      this.title = traitDefinition.title;
      this.text = traitDefinition.text;
      this.type = traitDefinition.type;
      this.icon = traitDefinition.icon;
    }
  }
}

export type traitDefinition = {
  type: TraitType;
  title: string;
  text: string;
  icon: string;

  class: typeof Trait;
};
